export const GITHUB_GRAPHQL_ENDPOINT = "https://api.github.com/graphql";
